var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApartmentFinderIconNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 76,
    viewBox: "0 0 78 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1433_9",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 78,
    height: 73
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.6665 2H0V74.8122H77.6665V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1433_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7922 46.2195C41.1771 49.6782 35.606 51.6306 29.839 51.8103C24.072 51.9901 18.39 50.3886 13.568 47.224C1.25296 39.3525 -1.68218 21.9283 8.37505 11.3714C17.9398 1.30643 35.2218 2.14689 45.1148 10.8588C55.6852 19.9195 54.5152 35.8267 46.4694 46.0557C45.628 47.06 47.1262 48.5566 47.9678 47.5521C56.6908 36.5031 57.3681 22.0923 48.132 11.0229C39.0805 -0.353982 19.787 -0.538513 8.88819 8.00958C-3.20091 17.562 -2.03111 32.9773 6.83581 44.2107C16.5851 56.5101 34.524 56.6126 46.6131 48.0645C47.9473 47.388 46.7773 45.5431 45.7717 46.2195H45.7922Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4629 48.8955C55.8486 57.0951 65.988 65.6431 75.8195 74.5398C76.8251 75.3598 78.344 74.0272 77.3382 73.0227C67.2605 64.1468 57.1418 55.5987 46.8791 47.3786C45.8736 46.5382 44.3546 48.0551 45.5451 48.8955H45.4629Z",
    fill: "#030201"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartmentFinderIconNew);
export default __webpack_public_path__ + "static/media/apartment-finder-icon-new.2cc8123918d31ad22b1e894a8fe77c8a.svg";
export { ForwardRef as ReactComponent };